import React from 'react';
// import { Route, Redirect } from 'react-router-dom';
import { history, ajaxPost } from '../global';
import { AsyncSelectField, DateTimeField, DateField, TextField, NumberField, DisplayJson, Label, DynamicLabel, CheckboxField, CollapsePanel } from "../components/FormControl";
import {
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Collapse,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';
const ProgressBar = require('react-progress-bar-plus');
require('react-progress-bar-plus/lib/progress-bar.css');

import NonUpdateFragment from './NonUpdateFragment';
import ReactLoading from 'react-loading';
import withProgressBar from './withProgressBar';


const searchUrl = {
  //Kiosk
  '/Kiosk/Home/StockTakeSearch': ['/Kiosk/Home/StockTakeForm', '/Kiosk/Home/Manager/StockTakeForm'],
  '/Kiosk/Home/Manager/StockTakeSearch': ['/Kiosk/Home/StockTakeForm', '/Kiosk/Home/Manager/StockTakeForm'],
  '/Kiosk/Home/StockTransferSearch': ['/Kiosk/Home/StockTransferSearch/StockTransferForm'],
  '/Kiosk/Home/GRNMarkPO': ['/Kiosk/Home/GRNMarkPO/GRNDetails'],
  '/Kiosk/Home/GRNSearch': ['/Kiosk/Home/GRNSearch/GRNDetails'],
  '/Kiosk/Home/PRApplicationSearch': ['/Kiosk/Home/PRApplicationSearch/PRApplicationForm'],
  //Web
  '/PRConfirmationSearch': ['/PRConfirmation'],
  '/POSearch': ['/PurchaseOrder', '/ModifyPurchaseOrder'],
  '/SuppInvSearch': ['/SuppInv'],
  '/DNSearch': ['/DeliveryNote'],
  '/StockTransferSearch': ['/StockTransfer'],
  '/StockAdjustmentSearch': ['/StockAdjustment'],
  '/BOMSearch': ['/BOMEntry']

};

const WithFormEvent = function (TargetForm, eventHanlders) {

  return withProgressBar(class form extends React.Component {
    constructor(props) {
      super(props);

      console.log("=========WithFormEvent=========", props);
      this.defaultValues = {};

      if (typeof eventHanlders.defaultValues == 'function') this.defaultValues = eventHanlders.defaultValues();

      this.state = {
        isGetFormData: false,
        isSubmitted: false,
        values: { ...this.defaultValues, ...props.values },
        errors: {},
        disableds: { ...eventHanlders.disableds },
        progress: 0,
        afterClick: false,
        detailForm: props.detailForm == "Y",
        DocType: eventHanlders.formName,
        enableEditLock: false,
        valuesToLock: false,
        editMode: false
      };

      this.comboUpdateWhenValuesChange = eventHanlders.comboUpdateWhenValuesChange || [];
      this.validatePattern = eventHanlders.validatePattern || {};
      this.fieldChange = eventHanlders.fieldChange || {};
      this.customProps = eventHanlders.customProps || {};
      this.formComponents = {};
      this.bodyEvent = { ...props.bodyEvent };

      this.customGetFormData = eventHanlders.getFormData;
      this.afterClick = false;
      this.progress = 0;

      //console.log(this.fieldChange);
      if (this.customProps && this.customProps.updateSessionShareUrl) {
        this.customProps.sessionShareUrl = this.customProps.updateSessionShareUrl(history);
      }
    }

    // updateProgressBar = (progress) => {
    //   this.setState({
    //     progress: progress
    //   });
    // }

    updateFieldComponent = (field, forceUpdate) => {

      if (this.formComponents[field]) {
        if (forceUpdate)
          if (this.formComponents[field].purgeCache) {
            this.formComponents[field].purgeCache();
          }
        this.formComponents[field].setState({});
      }
    }

    validateFieldValue = (field, value) => {
      var pattern = this.validatePattern[field];
      //console.log(pattern);
      if (pattern) {
        for (var pro in pattern) {
          switch (pro) {
            case "required":
              if (!value) this.state.errors[field] = pattern[`${pro}Error`] || `${field} required`;
              else this.state.errors[field] = undefined;
              break;

            case "pattern":
              if (!value) break;
              //console.log(pattern["pattern"]);
              const regex = RegExp(pattern["pattern"]);
              if (!regex.test(value)) this.state.errors[field] = pattern[`${pro}Error`] || `${field} invalid`;
              else this.state.errors[field] = undefined;
              break;

            case "customValidate":
              var customValidate = pattern["customValidate"];
              var error = customValidate(value);
              if (error) this.state.errors[field] = error;
              else this.state.errors[field] = undefined;
              break;

          }
          if (this.state.errors[field]) break;
        }
      }
      // //console.log(field);
      // //console.log(value);
      // //console.log(this.state.errors);
    }

    setFieldValue = (field, value) => {
      this.state.values[field] = value;

      if (value !== 0 && !value)
        delete this.state.values[field];


      this.validateFieldValue(field, value);

      if (this.fieldChange[field])
        this.fieldChange[field](this.state.values, this.updateFieldComponent, this.setFieldValue, this);

      window.isFormDirty = true;
    }

    getFormData = (params, callback) => {
      //console.log("getFormData");
      this.state.isSubmitted = false;
      this.state.params = params;

      //Modified by Ning: use key fields only on 20201007
      //Modified by Ning: Add values to get Form Data
      // eventHanlders.getFormData({ ...this.state.values, ...params }, data => {


      if (this.customGetFormData)
        this.customGetFormData(params, data => {

          let { values, disableds } = data;

          for (var pro in this.state.errors) {
            delete this.state.errors[pro];
          }

          if (this.bodyEvent["bodyInstance"]) {

            this.bodyEvent["bodyInstance"].forEach(bodyInstance => {

              for (var pro in bodyInstance.state.errors) {
                delete bodyInstance.state.errors[pro];
              }
            });

          }

          if (disableds) {
            this.state.disableds = disableds;
          }

          if (callback)
            callback(values);

          this.setState({
            values: values,
            afterSave: true
          });

          //check pervcode and currentcode
          var currentCode = params.Code;
          var pervCode = sessionStorage[history.location.pathname] ? JSON.parse(sessionStorage[history.location.pathname]).Code : "";
          console.log("======================= pervCode =======================", pervCode)
          console.log("======================= currentCode =======================", currentCode)
          // if (sessionStorage[history.location.pathname] && this.state.enableEditLock && this.state.editMode
          //   && this.state.valuesToLock && pervCode == params.Code)
          //     currentCode = pervCode;
          if (!currentCode)
            this.hasValuesToLock(false);
          else
            this.hasValuesToLock(true);
          sessionStorage[history.location.pathname] = JSON.stringify(params);

          this.state.afterSave = false;

          this.comboUpdateWhenValuesChange.forEach(field => {

            if (this.formComponents[field])
              this.formComponents[field].purgeCache();
          });

          if (sessionStorage[history.location.pathname] && this.state.enableEditLock && this.state.editMode
            && pervCode != currentCode && !params.refreshByEditMode)
            this.enableEditMode(false, { Code: pervCode }, true);

        }, {
          onSubmit: this.onSubmit,
        });
    }

    copyFormData = (params, keyFields) => {

      confirm("Please confirm to copy the current record", () => {
        this.getFormData(params, (values) => {
          keyFields.forEach(field => {
            delete values[field];
          })
        });
      })


    }
    //return the flag to child component without trigger the render function
    isAfterSave = () => {
      return this.state.afterSave;
    }

    validate = () => {
      for (var pro in this.validatePattern) {
        this.validateFieldValue(pro, this.state.values[pro]);
      }
      console.log("this.bodyEvent", this.bodyEvent);
      if (this.bodyEvent["validate"]) {
        this.bodyEvent["validate"].forEach(tmpFunction => {
          tmpFunction();
        })
      }

      console.log("this.bodyEvent", this.bodyEvent);
    }

    onSubmit = (callback) => {

      console.log('this.state.values:', this.state.values);

      if (window.ajaxCount !== 0 || this.state.afterClick) {
        alert('The last request is being processed. Please try again');
        return Promise.resolve({});
      }

      this.validate();

      // if (this.state.isSubmitted)
      //   return Promise.resolve({});

      //console.log(this.state.values);
      this.state.isSubmitted = true;
      // console.log(this.state.errors);

      // console.log("onsubmit - : After Click : ", this.state.afterClick)
      // if (this.state.afterClick)
      //   return Promise.resolve({});
      this.state.afterClick = true;
      // console.log("onsubmit - : After Click : ", this.state.afterClick)

      var isValid = true;
      var firstInValidComponent;
      for (var pro in this.state.errors) {
        if (pro && this.state.errors[pro]) {
          // this.setState({});

          // console.log(this.formComponents);
          if (this.formComponents[pro] && !firstInValidComponent)
            firstInValidComponent = this.formComponents[pro];

          isValid = false;
          // return Promise.resolve({});
        }
      }


      if (this.bodyEvent["bodyInstance"]) {

        for (var i = 0, bodyInstance; bodyInstance = this.bodyEvent["bodyInstance"][i]; i++) {
          console.log("bodyInstance.state.errors=====", bodyInstance.state.errors);

          for (var pro in bodyInstance.state.errors) {
            if (pro && bodyInstance.state.errors[pro]) {
              // bodyInstance.setState({});

              if (bodyInstance.formComponents[pro] && !firstInValidComponent)
                firstInValidComponent = bodyInstance.formComponents[pro];

              isValid = false;
              // return Promise.resolve({});
            }
          }

        }

      }


      if (!isValid) {
        this.state.afterClick = false;
        this.setState({});
        firstInValidComponent.focus();

        return Promise.resolve({});
      }
      // console.log('this.state.values:', this.state.values);

      // this.setState({
      //   progress: 10
      // });
      // if(this.props.updateProgressBar)
      this.progress = 0;
      this.props.updateProgressBar(10);

      var promiseObj = eventHanlders.onSubmit(this.state.values, data => {

        this.state.isSubmitted = false;
        this.state.afterClick = false;

        // if(callback)
        //   callback();

        let { values, disableds } = data;


        if (disableds) {
          this.state.disableds = disableds;
        }


        //update the flag to force the asyn select control to clear the cache
        this.setState({
          afterSave: true,
          values: values
        });

        console.log("this.state: ", this.state)
        if (callback && typeof callback === "function") {
          callback();
        }

        //reset the flag
        this.state.afterSave = false;
        window.isFormDirty = false;


      }, {
        refreshFormData: this.refreshFormData,
        ...this.props

      });

      sessionStorage[history.location.pathname] = JSON.stringify(this.state.values);
      console.log('promiseObj:', promiseObj);
      if (promiseObj) {
        promiseObj.then(() => {
          this.state.afterClick = false;
          // this.setState({});
          this.props.updateProgressBar(100);
          // this.setState({
          //   progress: 100
          // });
          // if(this.props.updateProgressBar)
          // this.props.updateProgressBar(100);
        });
      }
      // else {
      //   this.state.afterClick = false;

      //   this.props.updateProgressBar(100);
      //   this.setState({
      //     progress: 100
      //   });
      //   if(this.props.updateProgressBar)
      //   this.props.updateProgressBar(100);
      // }

      // console.log("onsubmit - : After Click : After Progress", this.state.afterClick)
      return promiseObj;


    }

    initData = () => {

      for (var pro in this.state.values) {
        delete this.state.values[pro];
      }
      Object.assign(this.state.values, this.defaultValues, this.props.values);
      for (var pro in this.state.disableds) {
        delete this.state.disableds[pro];
      }
      Object.assign(this.state.disableds, eventHanlders.disableds);

      this.setState({});
    }

    saveData = () => {

      // for (var pro in this.validatePattern) {
      //   this.validateFieldValue(pro, this.state.values[pro]);
      // }
      // if (this.bodyEvent["validate"]) this.bodyEvent["validate"]();

      this.validate();

      this.state.isSubmitted = true;

      for (var pro in this.state.errors) {
        if (pro && this.state.errors[pro]) {
          this.setState({});

          // console.log(this.formComponents);
          if (this.formComponents[pro])
            this.formComponents[pro].focus();

          return;
        }
      }

      if (this.props.saveData)
        this.props.saveData(this.state.values);







    }

    enableEditLock = (enable) => {
      this.setState({
        enableEditLock: enable
      })
    }

    enableEditMode = (enable, changeDoc, needReleaseLock = false) => {
      this.state.editMode = enable;
      if (enable) {
        this.checkIsLockRecord(this.state.params, response => {
          if (response.locked) {
            this.enableEditMode(false);
            alert(response.msg);
          }
          else {
            if (response.autoLocked) {
              this.state.params.refreshByEditMode = true;
              this.getFormData(this.state.params)
            } else {
              this.enableEditMode(false);
            }

            alert(response.msg);
          }
        })
      } else {

        if (needReleaseLock && !changeDoc) {

          this.releaseLockedRecord(this.state.params, response => {
            alert(response.msg);
          });

        } else if (needReleaseLock && changeDoc) {
          changeDoc.DocType = this.state.DocType;
          this.releaseLockedRecord(changeDoc, response => {
            alert(response.msg);
          });
        }
      }


      this.setState({});
    }

    hasValuesToLock = (hasValues) => {
      this.setState({
        valuesToLock: hasValues,
      })
    }

    checkIsLockRecord = (params, callback) => {
      console.log("===============================check lock====================================", params)
      var url = "FB.CheckLockedDoc";
      var data = {
        DocNo: params.Code,
        DocType: this.state.DocType,
        autoLock: this.state.editMode
      };

      ajaxPost(url, data).then(response => {
        if (callback)
          callback(response);
      });
    }

    releaseLockedRecord = (params, callback) => {
      console.log("===============================release lock====================================", params)
      var url = "FB.ReleaseLockedDoc";
      var data = {
        DocNo: params.Code,
        DocType: this.state.DocType
      };

      ajaxPost(url, data).then(response => {
        if (callback)
          callback(response);
      });
    }

    componentDidMount() {

      // console.log('-----WithFormEvent componentDidMount-----');
      // console.log('this.nameInput', this.nameInput);
      // console.log('this.props', this.props);
      //Test keep search criteria 


      // if (this.props.location) {
      //   var currentUrl = this.props.location.pathname;
      //   if (sessionStorage[currentUrl]) {
      //     this.state.values = JSON.parse(sessionStorage[currentUrl]);
      //     delete sessionStorage[currentUrl];
      //     // if (!currentUrl.startsWith('/Kiosk/Home'))
      //       //   this.nameInput.updateFilters();
      //       // else 
      //       // this.onSubmit();
      //     // this.onSubmit();
      //   }
      // }

      // console.log('-----WithFormEvent componentDidMount end-----');
      //Test keep search criteria end

      if (history.location.state && this.state.detailForm) {
        Object.assign(this.state.values, { ...history.location.state });
      }

      if (eventHanlders.enableRefresh && !window.TargetSearch && !this.props.Dashboard) {
        var param = null;

        if (history.location.state)
          param = this.state.values;
        if ((!history.location.state) || (history.location.state && !history.location.state.needRefresh))
          this.refreshFormData(param);
      }

      console.log("eventHanlders.enableEditLock", eventHanlders.enableEditLock);
      if (eventHanlders.enableEditLock) {
        this.bodyEvent["enableEditLock"] = (enable) => this.enableEditLock(enable);
        this.bodyEvent["enableEditMode"] = (enable, changeDoc, releaseLock = false) => this.enableEditMode(enable, changeDoc, releaseLock);
        this.bodyEvent["hasValuesToLock"] = (hasValues) => this.hasValuesToLock(hasValues);
        this.enableEditLock(true);

        window.addEventListener("beforeunload", this.cleanUpEditLock);
      }

      // sessionStorage["currentURL"] = window.location.href;

      // if(sessionStorage[this.props.history.location.pathname]){
      //   this.state.values = JSON.parse(sessionStorage[this.props.history.location.pathname]);
      //   // this.setState({});

      //   this.onSubmit();
      // } 
      //console.log(this.state.values);

    }
    componentDidUpdate() {
      if (this.progress != 100) {
        this.props.updateProgressBar(100);
        this.progress = 100;
      }
    }
    componentWillUnmount() {
      //Test keep search criteria

      // console.log('-----WithFormEvent componentWillUnmount-----', this.props);
      // console.log('this.nameInput', this.nameInput);
      // console.log('this.props', this.props);
      // var currentUrl = this.props.location.pathname;
      // var nextUrl = history.location.pathname;

      // console.log('componentDidMount', currentUrl);
      // console.log('componentDidMount', nextUrl);

      // const { Result, ...criteria } = this.state.values;
      // sessionStorage[currentUrl] = JSON.stringify(criteria);

      if (this.props.location) {

        var currentUrl = this.props.location.pathname;
        var nextUrl = history.location.pathname;
        var nextlocation = history.location;
        var nextState = history.location.state;
        // delete sessionStorage[currentUrl];

        // if(!nextlocation.state)
        if (nextlocation.state)
          delete sessionStorage[nextUrl];
        if (this.customProps && this.customProps.sessionShareUrl && this.customProps.sessionShareUrl.includes(nextUrl)) {

        } else {
          for (const key in sessionStorage) {
            if (!key.startsWith("/")) continue;
            if (key == "/login") continue;
            delete sessionStorage[key];
          }

        }

        // const { Result, ...criteria } = this.state.values;
        // sessionStorage[currentUrl] = JSON.stringify(criteria);

        // if (searchUrl[currentUrl] && searchUrl[currentUrl].includes(nextUrl) && this.state.values.Result) {
        //   const { Result, ...criteria } = this.state.values;
        //   sessionStorage[currentUrl] = JSON.stringify(criteria);
        // }
        // else {
        //   if (sessionStorage[currentUrl])
        //     delete sessionStorage[currentUrl];
        // }
      }

      if (this.props.isPopup) {
        var currentUrl = history.location.pathname;
        delete sessionStorage[currentUrl];
      }
      if (this.state.enableEditLock && this.state.valuesToLock && this.state.editMode) {
        this.releaseLockedRecord(this.state.params);
      }

      if (this.state.enableEditLock) {
        window.removeEventListener("beforeunload", this.cleanUpEditLock);
      }

      // console.log('-----WithFormEvent componentWillUnmount-----', this.props);
      //Test keep search criteria end

      // sessionStorage[sessionStorage["currentURL"]] = JSON.stringify(this.state.values);
    }

    cleanUpEditLock = () => {
      if (this.state.enableEditLock && this.state.valuesToLock && this.state.editMode) {
        this.releaseLockedRecord(this.state.params);
      }
    }

    refreshFormData = (params) => {



      if (params) {
        sessionStorage[history.location.pathname] = JSON.stringify(params);
        setTimeout(() => {
          this.getFormData(params);
          this.enableEditMode(false);
        });
        return;
      }

      if (sessionStorage[history.location.pathname]) {
        let params = JSON.parse(sessionStorage[history.location.pathname]);
        if (Object.keys(params).length > 0 && window.ajaxCount == 0 && !this.afterClick)
          setTimeout(() => {
            this.getFormData(params);
            this.enableEditMode(false);
          });
      }

    }

    shouldComponentUpdate(nextProps, nextState) {
      // console.log("With form event shouldComponentUpdate: ", nextProps);
      if (nextProps.values)
        this.state.values = { ...nextProps.values };
      // else {
      //   this.state.values = {};
      // }
      return true;
    }
    render() {

      // console.log('with form event', this.props);

      const { values, onSubmit, getFormData, validatePattern, ...passEventHanlders } = eventHanlders;
      const standardProps = {
        values: this.state.values,
        errors: this.state.errors,
        disableds: this.state.disableds,
        isGetFormData: this.state.isGetFormData,
        setFieldValue: this.setFieldValue,
        isSubmitted: this.state.isSubmitted,
        formComponents: this.formComponents,
        customProps: this.customProps,
      };

      // console.log("standardProps", standardProps);
      return (
        <div>
          {this.state.enableEditLock && <div className="text-right">
            {/* <Loading> */}
            {this.state.valuesToLock && <Button hidden={this.state.editMode} color="default" onClick={() => {
              this.enableEditMode(true);
            }} ><i className="fa fa-edit"></i> <Label>Edit</Label></Button>}
            {this.state.valuesToLock && <Button hidden={!this.state.editMode} color="danger" onClick={() => {
              this.checkIsLockRecord(this.state.params, response => {
                if (response && response.locked) {
                  alert("Cannot unlock as someone locked this record.");
                  this.enableEditMode(false, false, false);
                  //return;
                } else {
                  this.enableEditMode(false, false, true);
                }
              });
            }} ><i className="fa fa-times"></i> <Label>Cancel</Label></Button>}
          </div>}
          <TargetForm {...this.props} {...passEventHanlders}
            ref={(input) => {
              this.nameInput = input;
            }}
            isAfterSave={this.isAfterSave}
            validate={this.validate}
            onSubmit={this.onSubmit}
            getFormData={this.getFormData}
            bodyEvent={this.bodyEvent}
            standardProps={standardProps}
            saveData={this.saveData}
            initData={this.initData}
            copyFormData={this.copyFormData}
            refreshFormData={this.refreshFormData}
            updateFieldComponent={this.updateFieldComponent}
            updateProgressBar={this.props.updateProgressBar}
            editLockEditMode={this.state.editMode}
          // values={this.state.values}
          // errors={this.state.errors}
          // isSubmitted={this.state.isSubmitted}
          // isGetFormData={this.state.isGetFormData}
          // setFieldValue={this.setFieldValue}
          // formComponents={}
          />
        </div>
      );

    }
  })
}

export default WithFormEvent;



// WEBPACK FOOTER //
// ./src/components/WithFormEvent.js